import { Col, Container, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { Chip } from "@amzn/uxm-stencil-react-components/lib/src/stencil/chip";
import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { UserPermissions } from "lib/services";
import React, { useState } from "react";

import {
  CFMModuleName,
  CustomerFeedback,
  CustomerFeedbackAlignment,
  CustomerFeedbackIconPosition,
  CustomerFeedbackPopUpAlignment,
  CustomerFeedbackPopUpHeight,
} from "../CustomerFeedback";
import ExpanderQuestion from "../ExpanderQuestion/ExpanderQuestion";

enum Category {
  software = "software",
  hardware = "hardware",
  all = "all",
}

const FAQWidget = (): React.JSX.Element => {
  const useHardwareShop = UserPermissions.current.hasPermission(PERMISSIONS.USE_HARDWARE_SHOP);

  const [selectedCategory, setSelectedCategory] = useState<Category>(
    useHardwareShop ? Category.all : Category.software
  );
  const isSelected = (categories: Category[]) => categories.includes(selectedCategory);

  return (
    <Container data-test-id="faq-widget" isFullWidth={true}>
      <Col gridGap="S300">
        {/* Title */}
        <Text fontSize={"T300"} fontWeight="bold" color="neutral90">
          {getString(`home.faqTitle`)}
        </Text>

        {/* Questions categories */}
        {useHardwareShop && (
          <Col gridGap="S300">
            <Row gridGap="S250">
              <Chip
                touchpoint="faq-all"
                data-test-id="chip-all"
                isSelected={isSelected([Category.all])}
                onClick={() => setSelectedCategory(Category.all)}
              >
                {getString(`home.all`)}
              </Chip>
              <Chip
                touchpoint="faq-software"
                data-test-id="chip-software"
                isSelected={isSelected([Category.software])}
                onClick={() => setSelectedCategory(Category.software)}
              >
                {getString(`home.software`)}
              </Chip>
              <Chip
                touchpoint="faq-hardware"
                data-test-id="chip-hardware"
                isSelected={isSelected([Category.hardware])}
                onClick={() => setSelectedCategory(Category.hardware)}
              >
                {getString(`home.hardware`)}
              </Chip>
            </Row>
          </Col>
        )}

        {/* Questions */}
        <Col gridGap="S300">
          {isSelected([Category.all, Category.software]) && (
            <ExpanderQuestion
              title={getString(`home.faq.software.question1`)}
              content={getString(`home.faq.software.answer1`)}
            />
          )}
          {isSelected([Category.all, Category.software]) && (
            <ExpanderQuestion
              title={getString(`home.faq.software.question2`)}
              content={getString(`home.faq.software.answer2`)}
            />
          )}
          {isSelected([Category.all, Category.software]) && (
            <ExpanderQuestion
              title={getString(`home.faq.software.question3`)}
              content={getString(`home.faq.software.answer3`)}
            />
          )}
          {isSelected([Category.all, Category.software]) && (
            <ExpanderQuestion
              title={getString(`home.faq.software.question4`)}
              content={getString(`home.faq.software.answer4`)}
            />
          )}
          {isSelected([Category.all, Category.software]) && (
            <ExpanderQuestion
              title={getString(`home.faq.software.question5`)}
              content={getString(`home.faq.software.answer5`)}
            />
          )}
          {isSelected([Category.all, Category.hardware]) && (
            <ExpanderQuestion
              title={getString(`home.faq.hardware.question1`)}
              content={getString(`home.faq.hardware.answer1`)}
            />
          )}
          {isSelected([Category.all, Category.hardware]) && (
            <ExpanderQuestion
              title={getString(`home.faq.hardware.question2`)}
              content={getString(`home.faq.hardware.answer2`)}
            />
          )}
          {isSelected([Category.all, Category.hardware]) && (
            <ExpanderQuestion
              title={getString(`home.faq.hardware.question3`)}
              content={getString(`home.faq.hardware.answer3`)}
            />
          )}
          {isSelected([Category.all, Category.hardware]) && (
            <ExpanderQuestion
              title={getString(`home.faq.hardware.question4`)}
              content={getString(`home.faq.hardware.answer4`)}
            />
          )}
          {isSelected([Category.all, Category.hardware]) && (
            <ExpanderQuestion
              title={getString(`home.faq.hardware.question5`)}
              content={getString(`home.faq.hardware.answer5`)}
            />
          )}
          {isSelected([Category.all, Category.hardware]) && (
            <ExpanderQuestion
              title={getString(`home.faq.hardware.question6`)}
              content={getString(`home.faq.hardware.answer6`)}
            />
          )}
        </Col>

        {/* CFM */}
        <CustomerFeedback
          moduleName={CFMModuleName.exploreItmp}
          alignment={CustomerFeedbackAlignment.Left}
          position={CustomerFeedbackIconPosition.Left}
          popUpXAlignment={CustomerFeedbackPopUpAlignment.Right}
          popUpYAlignment={CustomerFeedbackPopUpHeight.Top}
        />
      </Col>
    </Container>
  );
};

export default FAQWidget;
